import { render, staticRenderFns } from "./LeftNavigation.vue?vue&type=template&id=c23d8dde&scoped=true"
import script from "./LeftNavigation.vue?vue&type=script&lang=js"
export * from "./LeftNavigation.vue?vue&type=script&lang=js"
import style0 from "./LeftNavigation.vue?vue&type=style&index=0&id=c23d8dde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23d8dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c23d8dde')) {
      api.createRecord('c23d8dde', component.options)
    } else {
      api.reload('c23d8dde', component.options)
    }
    module.hot.accept("./LeftNavigation.vue?vue&type=template&id=c23d8dde&scoped=true", function () {
      api.rerender('c23d8dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/LeftNavigation.vue"
export default component.exports